<onsip-header-main>
  @if (isBasic) {
  <onsip-header-page-title>Basic ACD queue</onsip-header-page-title>
  } @if (isEnhanced) {
  <onsip-header-page-title>Enhanced ACD queue</onsip-header-page-title>
  } @if (!isBasic && !isEnhanced) {
  <onsip-header-page-title>ACD queue</onsip-header-page-title>
  }
</onsip-header-main>
@if (isBasic) {
<div class="mat-body-2">
  {{ basicHeaderAgentPricingText }}
</div>
} @if (isEnhanced) {
<div class="mat-body-2">
  {{ enhancedHeaderAgentPricingText }}
</div>
} @if (!isBasic && !isEnhanced) {
<div>
  <div class="mat-headline-5">Select a queue type to begin setup</div>
  <div class="features-container onsip-grid-placement">
    <div class="first-column">
      <mat-card>
        <span>
          <mat-card-title class="features-title">Basic queue</mat-card-title>
          <mat-card-content class="features-content">
            <div class="priceline mat-body-1">{{ basicAgentPricingText }}</div>
            <div>Configure general settings for queues, call handling and agents</div>
          </mat-card-content>
        </span>
        <button
          mat-stroked-button
          color="primary"
          (click)="setQueueType('basic')"
          [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_BASIC_QUEUE_SETUP_BTN"
        >
          Set up a basic queue
        </button>
      </mat-card>
    </div>
    <div class="second-column">
      <mat-card>
        <span>
          <mat-card-title class="features-title">Enhanced queue</mat-card-title>
          <mat-card-content class="features-content">
            <div class="priceline mat-body-1">{{ enhancedAgentPricingText }}</div>
            <div class="mat-card-text">
              Includes basic queue features, plus reporting and call recording capabilities
            </div>
          </mat-card-content>
        </span>
        <button
          mat-stroked-button
          color="primary"
          (click)="setQueueType('enhanced')"
          [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_ENHANCED_QUEUE_SETUP_BTN"
        >
          Set up an enhanced queue
        </button>
      </mat-card>
    </div>
  </div>
</div>
} @if (isBasic || isEnhanced) {
<div>
  <onsip-loading-container
    [deferCond]="loadingStateComplete$"
    [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
  >
    <form
      onsipFormTracking
      [formGroup]="queueInfo"
      name="adv-queue-setup-wizard"
      id="adv-queue-setup-wizard"
      (ngSubmit)="submit()"
    >
      <mat-horizontal-stepper #stepper linear class="onsip-stepper-disabled-header">
        <mat-step #basicStep [stepControl]="queueInfo" completed="false">
          <div class="mat-headline-5">Basic queue settings</div>
          <ng-template *ngTemplateOutlet="queueBasicForm"></ng-template>
          <span class="navigation-buttons no-back">
            <button
              mat-button
              type="button"
              color="primary"
              class="cancel-button right-buttons"
              (click)="handleCancel()"
            >
              {{ "ONSIP_I18N.CANCEL" | translate }}
            </button>
            <button
              type="button"
              mat-raised-button
              color="primary"
              class="right-buttons"
              (click)="nextStep('basic')"
              [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_ADD_GO_TO_AGENT_SETTINGS_STEP"
            >
              {{ "ONSIP_I18N.NEXT" | translate }}
            </button>
          </span>
        </mat-step>
        <mat-step #agentStep [stepControl]="queueInfo" completed="false">
          <div class="mat-headline-5">Agent settings</div>
          <ng-template *ngTemplateOutlet="queueAgentForm"></ng-template>
          @if (!isMobile) {
          <div class="navigation-buttons">
            <button type="button" mat-stroked-button color="primary" (click)="backStep()">
              {{ "ONSIP_I18N.BACK" | translate }}
            </button>
            <span>
              <button
                mat-button
                type="button"
                color="primary"
                class="cancel-button right-buttons"
                (click)="handleCancel()"
              >
                {{ "ONSIP_I18N.CANCEL" | translate }}
              </button>
              <button
                type="button"
                mat-raised-button
                color="primary"
                class="right-buttons"
                (click)="nextStep()"
                [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_ADD_GO_TO_CALLER_SETTINGS_STEP"
              >
                {{ "ONSIP_I18N.NEXT" | translate }}
              </button>
            </span>
          </div>
          } @if (isMobile) {
          <div class="navigation-mobile-buttons">
            <button
              type="button"
              mat-raised-button
              color="primary"
              (click)="nextStep()"
              [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_ADD_GO_TO_CALLER_SETTINGS_STEP"
            >
              {{ "ONSIP_I18N.NEXT" | translate }}
            </button>
            <button type="button" mat-stroked-button color="primary" (click)="backStep()">
              {{ "ONSIP_I18N.BACK" | translate }}
            </button>
            <button mat-button type="button" color="primary" (click)="handleCancel()">
              {{ "ONSIP_I18N.CANCEL" | translate }}
            </button>
          </div>
          }
        </mat-step>
        <mat-step #callerStep [stepControl]="queueInfo" completed="false">
          <div class="mat-headline-5">Caller settings</div>
          <ng-template *ngTemplateOutlet="queueCallerForm"></ng-template>
          @if (!isMobile) {
          <div class="navigation-buttons">
            <button type="button" mat-stroked-button color="primary" (click)="backStep()">
              {{ "ONSIP_I18N.BACK" | translate }}
            </button>
            <span>
              <button
                mat-button
                type="button"
                color="primary"
                class="cancel-button right-buttons"
                (click)="handleCancel()"
              >
                {{ "ONSIP_I18N.CANCEL" | translate }}
              </button>
              <button
                type="button"
                mat-raised-button
                color="primary"
                class="right-buttons"
                (click)="nextStep('caller')"
                [attr.data-cy]="
                  isEnhanced
                    ? E2eLocators.ADMIN_ACD_QUEUE_ADD_GO_TO_ENHANCED_SETTINGS_STEP
                    : E2eLocators.ADMIN_ACD_QUEUE_ADD_GO_REVIEW
                "
              >
                {{ "ONSIP_I18N.NEXT" | translate }}
              </button>
            </span>
          </div>
          } @if (isMobile) {
          <div class="navigation-mobile-buttons">
            <button
              type="button"
              mat-raised-button
              color="primary"
              (click)="nextStep('caller')"
              [attr.data-cy]="
                isEnhanced
                  ? E2eLocators.ADMIN_ACD_QUEUE_ADD_GO_TO_ENHANCED_SETTINGS_STEP
                  : E2eLocators.ADMIN_ACD_QUEUE_ADD_GO_REVIEW
              "
            >
              {{ "ONSIP_I18N.NEXT" | translate }}
            </button>
            <button type="button" mat-stroked-button color="primary" (click)="backStep()">
              {{ "ONSIP_I18N.BACK" | translate }}
            </button>
            <button mat-button type="button" color="primary" (click)="handleCancel()">
              {{ "ONSIP_I18N.CANCEL" | translate }}
            </button>
          </div>
          }
        </mat-step>
        @if (isEnhanced) {
        <mat-step #enhancedStep [stepControl]="queueInfo" completed="false">
          <div class="mat-headline-5">Enhanced queue</div>
          <ng-template *ngTemplateOutlet="queueEnhancedForm"></ng-template>
          @if (!isMobile) {
          <div class="navigation-buttons">
            <button type="button" mat-stroked-button color="primary" (click)="backStep()">
              {{ "ONSIP_I18N.BACK" | translate }}
            </button>
            <span>
              <button
                mat-button
                type="button"
                color="primary"
                class="cancel-button right-buttons"
                (click)="handleCancel()"
              >
                {{ "ONSIP_I18N.CANCEL" | translate }}
              </button>
              <button
                type="button"
                mat-raised-button
                color="primary"
                class="right-buttons"
                (click)="nextStep('enhanced')"
                [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_ADD_GO_REVIEW"
              >
                {{ "ONSIP_I18N.NEXT" | translate }}
              </button>
            </span>
          </div>
          } @if (isMobile) {
          <div class="navigation-mobile-buttons">
            <button
              type="button"
              mat-raised-button
              color="primary"
              (click)="nextStep('enhanced')"
              [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_ADD_GO_REVIEW"
            >
              {{ "ONSIP_I18N.NEXT" | translate }}
            </button>
            <button type="button" mat-stroked-button color="primary" (click)="backStep()">
              {{ "ONSIP_I18N.BACK" | translate }}
            </button>
            <button mat-button type="button" color="primary" (click)="handleCancel()">
              {{ "ONSIP_I18N.CANCEL" | translate }}
            </button>
          </div>
          }
        </mat-step>
        }
        <mat-step #reviewStep [stepControl]="queueInfo">
          <span class="review-header">
            <div class="mat-headline-5">{{ "ONSIP_I18N.REVIEW" | translate }}</div>
            <button
              type="button"
              class="edit-info-button"
              mat-stroked-button
              color="primary"
              (click)="toggleEditPanel(showEditPanel)"
            >
              {{ showEditPanel ? "Cancel edits" : "Edit info" }}
            </button>
          </span>
          <div class="review-container">
            <div class="review-basic-container">
              <div class="mat-headline-6">Basic queue settings</div>
              @if (!showEditPanel) {
              <div class="review-view-container onsip-grid-placement">
                <div class="first-column">
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Queue name</div>
                    <div [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_ADD_REVIEW_NAME">
                      {{ queueInfo.controls.queueName.value || "n/a" }}
                    </div>
                  </div>
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Queue SIP address</div>
                    <div>{{ queueInfo.controls.queueSipAddress.value + "@" + domain }}</div>
                  </div>
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Queue extensions</div>
                    @if (queueInfo.controls.queueExtensions.value.length === 0) {
                    <div>None</div>
                    } @if (queueInfo.controls.queueExtensions.value.length > 0) {
                    <div>
                      @for (ext of queueInfo.controls.queueExtensions.value; track ext) {
                      <div [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_ADD_REVIEW_QUEUE_EXTENSIONS">
                        {{ ext | formatExtensions }}
                      </div>
                      }
                    </div>
                    }
                  </div>
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Login SIP address</div>
                    <div>{{ queueInfo.controls.loginSipAddress.value + "@" + domain }}</div>
                  </div>
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Login password</div>
                    <div [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_ADD_REVIEW_LOGIN_PASS">
                      {{ queueInfo.controls.loginPassword.value }}
                    </div>
                  </div>
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Login extensions</div>
                    @if (queueInfo.controls.loginExtensions.value.length === 0) {
                    <div>None</div>
                    } @if (queueInfo.controls.loginExtensions.value.length > 0) {
                    <div>
                      @for (ext of queueInfo.controls.loginExtensions.value; track ext) {
                      <div [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_ADD_REVIEW_LOGIN_EXTENSIONS">
                        {{ ext | formatExtensions }}
                      </div>
                      }
                    </div>
                    }
                  </div>
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Max callers in queue</div>
                    <div>{{ queueInfo.controls.maxCallers.value }}</div>
                  </div>
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Max agents</div>
                    <div>{{ queueInfo.controls.maxAgents.value }}</div>
                  </div>
                </div>
              </div>
              } @if (showEditPanel) {
              <ng-template
                *ngTemplateOutlet="queueBasicForm; context: { $implicit: 'one-column' }"
              ></ng-template>
              }
            </div>
            <mat-divider class="divider"></mat-divider>
            <div class="review-agent-container">
              <div class="mat-headline-6">Agent settings</div>
              @if (!showEditPanel) {
              <div class="review-view-container onsip-grid-placement">
                <div class="first-column">
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Ring strategy</div>
                    <div>{{ queueInfo.controls.ringStrategy.value }}</div>
                  </div>
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Ring duration</div>
                    <div>{{ queueInfo.controls.ringDuration.value + " seconds" }}</div>
                  </div>
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Connection delay</div>
                    <div>{{ queueInfo.controls.connectionDelay.value + " seconds" }}</div>
                  </div>
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Announce caller hold time to agent</div>
                    <div>{{ queueInfo.controls.reportHoldTime.value ? "Yes" : "No" }}</div>
                  </div>
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Post-call wrap up</div>
                    <div>{{ queueInfo.controls.wrapupTime.value + " seconds" }}</div>
                  </div>
                </div>
              </div>
              } @if (showEditPanel) {
              <ng-template
                *ngTemplateOutlet="queueAgentForm; context: { $implicit: 'one-column' }"
              ></ng-template>
              }
            </div>
            <mat-divider class="divider"></mat-divider>
            <div class="review-caller-container">
              <div class="mat-headline-6">Caller settings</div>
              @if (!showEditPanel) {
              <div class="review-view-container onsip-grid-placement">
                <div class="first-column">
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Announce hold time</div>
                    <div>
                      {{
                        queueInfo.controls.announceFrequency.value === "0"
                          ? "Never"
                          : queueInfo.controls.announceFrequency.value + " seconds"
                      }}
                    </div>
                  </div>
                  <div class="review-property">
                    <div class="mat-body-1 property-header">While on hold a caller hears</div>
                    <div>{{ queueInfo.controls.musicSource.value?.name }}</div>
                  </div>
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Caller timeout</div>
                    <div>{{ queueInfo.controls.callerTimeout.value + " seconds" }}</div>
                  </div>
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Failover address</div>
                    <div>
                      {{
                        queueInfo.controls.failoverAddress.value
                          ? queueInfo.controls.failoverAddress.value
                          : "None"
                      }}
                    </div>
                  </div>
                  <div class="review-property">
                    <div class="mat-body-1 property-header">Escape voicemail box</div>
                    <div>
                      {{
                        queueInfo.controls.escapeAddress.value !== "None"
                          ? "(Voicemail) " + queueInfo.controls.escapeAddress.value.name
                          : "None"
                      }}
                    </div>
                  </div>
                </div>
              </div>
              } @if (showEditPanel) {
              <ng-template
                *ngTemplateOutlet="queueCallerForm; context: { $implicit: 'one-column' }"
              ></ng-template>
              }
            </div>
            @if (isEnhanced) {
            <div>
              <mat-divider class="divider"></mat-divider>
              <div class="review-enhanced-container">
                <div class="mat-headline-6">Enhanced queue</div>
                @if (!showEditPanel) {
                <div class="review-view-container onsip-grid-placement">
                  <div class="first-column">
                    <div class="review-property">
                      <div class="mat-body-1 property-header">Enable queue reporting</div>
                      <div>{{ queueInfo.controls.queueReporting.value ? "Yes" : "No" }}</div>
                    </div>
                    <div class="review-property">
                      <div class="mat-body-1 property-header">Enable call recording</div>
                      <div>{{ queueInfo.controls.callRecording.value ? "Yes" : "No" }}</div>
                    </div>
                    @if (queueInfo.controls.callRecording.value) {
                    <div>
                      <div class="review-property">
                        <div class="mat-body-1 property-header">Stoarge service</div>
                        <div>
                          {{
                            queueInfo.controls.storageService.value?.name || "ONSIP_I18N.NONE"
                              | translate
                          }}
                        </div>
                      </div>
                      <div class="review-property">
                        <div class="mat-body-1 property-header">Recording announcement</div>
                        @if ( queueInfo.controls.recordingAnnouncement.value ===
                        recordingAnnouncement.none ) {
                        <div>None</div>
                        } @if ( queueInfo.controls.recordingAnnouncement.value ===
                        recordingAnnouncement.basic ) {
                        <div>Your call may be recorded.</div>
                        } @if ( queueInfo.controls.recordingAnnouncement.value ===
                        recordingAnnouncement.training ) {
                        <div>
                          Your call may be recorded for quality assurance and training purposes.
                        </div>
                        } @if ( queueInfo.controls.recordingAnnouncement.value ===
                        recordingAnnouncement.monitored ) {
                        <div>Your call may be monitored or recorded for quality assurance.</div>
                        }
                      </div>
                      <div class="review-property">
                        <div class="mat-body-1 property-header">
                          Play a tone periodically during call recording
                        </div>
                        <div>{{ queueInfo.controls.recordingTone.value ? "Yes" : "No" }}</div>
                      </div>
                    </div>
                    } @if (queueInfo.controls.queueReporting.value) {
                    <div>
                      <div class="review-property">
                        <div class="mat-body-1 property-header">Email reports</div>
                        @for (emailRepText of emailReportsAsArray; track emailRepText) {
                        <div>
                          <div>
                            ({{ emailRepText.frequency }})
                            <span
                              [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_ADD_REVIEW_ENHANCED_EMAIL"
                            >
                              {{ emailRepText.email }}
                            </span>
                          </div>
                        </div>
                        }
                      </div>
                    </div>
                    }
                  </div>
                </div>
                } @if (showEditPanel) {
                <ng-template
                  *ngTemplateOutlet="queueEnhancedForm; context: { $implicit: 'one-column' }"
                ></ng-template>
                }
              </div>
            </div>
            } @if (!isMobile) {
            <div class="navigation-buttons review-btns">
              <button type="button" mat-stroked-button color="primary" (click)="backStep(true)">
                {{ "ONSIP_I18N.BACK" | translate }}
              </button>
              @if (!showEditPanel) {
              <span>
                <button
                  mat-button
                  type="button"
                  color="primary"
                  class="cancel-button right-buttons"
                  (click)="handleCancel()"
                >
                  {{ "ONSIP_I18N.CANCEL" | translate }}
                </button>
                <button
                  type="submit"
                  mat-raised-button
                  color="primary"
                  class="right-buttons"
                  matStepperNext
                  [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_ADD_REVIEW_FINISH"
                >
                  {{ "ONSIP_I18N.SAVE__FINISH_SETUP" | translate }}
                </button>
              </span>
              } @if (showEditPanel) {
              <span>
                <button
                  mat-button
                  type="button"
                  color="primary"
                  class="cancel-button right-buttons"
                  (click)="handleCancel()"
                >
                  {{ "ONSIP_I18N.CANCEL" | translate }}
                </button>
                <button
                  type="button"
                  mat-raised-button
                  color="primary"
                  class="right-buttons"
                  (click)="toggleEditPanel()"
                >
                  {{ "ONSIP_I18N.REVIEW_AND_SUBMIT" | translate }}
                </button>
              </span>
              }
            </div>
            } @if (isMobile && !showEditPanel) {
            <div class="navigation-mobile-buttons">
              <button
                type="submit"
                mat-raised-button
                color="primary"
                class="right-buttons"
                matStepperNext
                [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_ADD_REVIEW_FINISH"
              >
                {{ "ONSIP_I18N.SAVE__FINISH_SETUP" | translate }}
              </button>
              <button type="button" mat-stroked-button color="primary" (click)="backStep()">
                {{ "ONSIP_I18N.BACK" | translate }}
              </button>
              <button mat-button type="button" color="primary" (click)="handleCancel()">
                {{ "ONSIP_I18N.CANCEL" | translate }}
              </button>
            </div>
            } @if (isMobile && showEditPanel) {
            <div class="navigation-mobile-buttons">
              <button type="button" mat-raised-button color="primary" (click)="toggleEditPanel()">
                {{ "ONSIP_I18N.REVIEW_AND_SUBMIT" | translate }}
              </button>
              <button type="button" mat-stroked-button color="primary" (click)="backStep()">
                {{ "ONSIP_I18N.BACK" | translate }}
              </button>
              <button mat-button type="button" color="primary" (click)="handleCancel()">
                {{ "ONSIP_I18N.CANCEL" | translate }}
              </button>
            </div>
            }
          </div>
        </mat-step>
        <!-- ng-template needs to be inside the stepper for template to work-->
        <ng-template #queueBasicForm let-column>
          <div class="basic-settings-form-container">
            <div class="onsip-grid-placement">
              <div class="first-column">
                <div class="property">
                  <div class="mat-body-1 property-header">Queue name</div>
                  <mat-form-field appearance="outline">
                    <input
                      matInput
                      formControlName="queueName"
                      autocomplete="off"
                      [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_ADD_NAME"
                    />
                    <mat-error>{{
                      getGenericError(queueInfo.controls.queueName, "Queue name")
                    }}</mat-error>
                  </mat-form-field>
                </div>
                <div class="property">
                  <div class="mat-body-1 property-header">Queue SIP address</div>
                  <onsip-sip-address-field formControlName="queueSipAddress">
                  </onsip-sip-address-field>
                </div>
                <div class="property m-b-28">
                  <div class="mat-body-1 property-header">Queue extensions</div>
                  <onsip-extensions-list #queueExtensionsList formControlName="queueExtensions">
                  </onsip-extensions-list>
                </div>
                @if (showEditPanel) {
                <ng-template *ngTemplateOutlet="secondColumn"></ng-template>
                } @if (showEditPanel) {
                <ng-template *ngTemplateOutlet="thirdColumn"></ng-template>
                }
              </div>
              @if (!showEditPanel) {
              <div class="second-column">
                <ng-template *ngTemplateOutlet="secondColumn"></ng-template>
              </div>
              }
              <ng-template #secondColumn>
                <div class="login-sip-address property">
                  <div class="mat-body-1 property-header">Login SIP address</div>
                  <onsip-sip-address-field formControlName="loginSipAddress">
                  </onsip-sip-address-field>
                </div>
                <div class="login-pw property">
                  <div class="mat-body-1 property-header">Login password</div>
                  <div class="field-grid-block">
                    <mat-form-field appearance="outline" class="filed-grid">
                      <input
                        matInput
                        formControlName="loginPassword"
                        autocomplete="off"
                        [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_ADD_LOGIN_PASS"
                      />
                      <mat-error>{{
                        getGenericError(queueInfo.controls.loginPassword, "Login password", true)
                      }}</mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="property">
                  <div class="mat-body-1 property-header">Login extensions</div>
                  <onsip-extensions-list #loginExtensionsList formControlName="loginExtensions">
                  </onsip-extensions-list>
                </div>
              </ng-template>
              @if (!showEditPanel) {
              <div class="third-column">
                <ng-template *ngTemplateOutlet="thirdColumn"></ng-template>
              </div>
              }
              <ng-template #thirdColumn>
                <div class="property">
                  <div class="mat-body-1 property-header">Max callers in queue</div>
                  <div class="field-grid-block">
                    <mat-form-field appearance="outline" class="filed-grid">
                      <input matInput required formControlName="maxCallers" autocomplete="off" />
                      <mat-error>{{
                        getGenericRequiredError(
                          queueInfo.controls.maxCallers,
                          "Max callers in queue"
                        )
                      }}</mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="property">
                  <div class="mat-body-1 property-header">Max agents</div>
                  <div class="field-grid-block">
                    <div class="agent-field-price-container filed-grid">
                      <mat-form-field appearance="outline">
                        <input matInput required formControlName="maxAgents" autocomplete="off" />
                        <mat-error>{{
                          getGenericRequiredError(queueInfo.controls.maxAgents, "Max agents")
                        }}</mat-error>
                      </mat-form-field>
                      <span class="mat-body-1 agent-price">{{
                        isBasic ? basicAgentPricingText : enhancedAgentPricingText
                      }}</span>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </ng-template>
        <ng-template #queueAgentForm let-column>
          <div class="agent-settings-form-container">
            <div class="onsip-grid-placement agent-settings">
              <div class="first-column">
                <div class="property with-hint">
                  <div class="mat-body-1 property-header">Ring Strategy</div>
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="ringStrategy">
                      @for (strategy of ringStrategies; track strategy) {
                      <mat-option [value]="strategy">
                        {{ strategy }}
                      </mat-option>
                      }
                    </mat-select>
                    @if (queueInfo.controls.ringStrategy.value === 'Roundrobin memory') {
                    <mat-hint
                      >Remembers the last agent to answer a call and rings the one next in
                      line</mat-hint
                    >
                    } @if (queueInfo.controls.ringStrategy.value === 'Random') {
                    <mat-hint>Sends call to a random agent</mat-hint>
                    } @if (queueInfo.controls.ringStrategy.value === 'Ring all') {
                    <mat-hint>Rings all agents simultaneously</mat-hint>
                    } @if (queueInfo.controls.ringStrategy.value === 'Least recent') {
                    <mat-hint>Rings the agent who has waited the longest to answer a call</mat-hint>
                    } @if (queueInfo.controls.ringStrategy.value === 'Fewest calls') {
                    <mat-hint>Rings the agent who has received the fewest calls</mat-hint>
                    }
                  </mat-form-field>
                </div>
                <div class="property">
                  <div class="mat-body-1 property-header">Ring duration</div>
                  <div class="field-grid-block">
                    <div class="filed-grid duration-flex">
                      <mat-form-field appearance="outline" class="duration-select">
                        <mat-select formControlName="ringDuration">
                          @for (duration of ringDurations; track duration) {
                          <mat-option [value]="duration">
                            {{ duration }}
                          </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <span class="seconds-text mat-body-1">seconds</span>
                    </div>
                  </div>
                </div>
                <div class="property">
                  <div class="mat-body-1 property-header">
                    Connection delay
                    <mat-icon
                      [matTooltip]="
                        'Gives agents time to accept and prepare for a call before connecting with the caller.'
                      "
                      matTooltipClass="onsip-tooltip-background"
                      [matTooltipPosition]="'above'"
                      class="tool-tip-icon"
                      >help_outline
                    </mat-icon>
                  </div>
                  <div class="field-grid-block">
                    <div class="filed-grid duration-flex">
                      <mat-form-field appearance="outline" class="duration-select">
                        <mat-select formControlName="connectionDelay">
                          @for (delay of connectionDelays; track delay) {
                          <mat-option [value]="delay">
                            {{ delay }}
                          </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <span class="seconds-text mat-body-1">seconds</span>
                    </div>
                  </div>
                </div>
                <div class="property announce-hold">
                  <mat-checkbox color="primary" class="mat-body-1" formControlName="reportHoldTime">
                    <mat-label>Announce caller hold time to agent</mat-label>
                  </mat-checkbox>
                </div>
                <div class="property">
                  <div class="mat-body-1 property-header">Post call wrap up</div>
                  <div class="field-grid-block">
                    <div class="filed-grid duration-flex">
                      <mat-form-field appearance="outline" class="duration-select">
                        <mat-select formControlName="wrapupTime">
                          @for (time of wrapupTimes; track time) {
                          <mat-option [value]="time">
                            {{ time }}
                          </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <span class="seconds-text mat-body-1">seconds</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #queueCallerForm let-column>
          <div class="caller-settings-form-container">
            <div class="onsip-grid-placement">
              <div class="first-column">
                <div class="property">
                  <div class="mat-body-1 property-header">Announce hold time</div>
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="announceFrequency">
                      @for (freq of announceFrequencies; track freq) {
                      <mat-option [value]="freq">
                        {{ freq === "0" ? "Never" : "Every " + freq + " seconds" }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="property moh-prop-flex">
                  <div class="mat-body-1 property-header">While on hold caller hears</div>
                  <mat-form-field
                    appearance="outline"
                    class="moh-field mobile-full-width"
                    onsip-form-field-flush-outline
                    onsip-hide-subscript-wrapper
                  >
                    <mat-select formControlName="musicSource">
                      @for (source of allMusicSources; track source) {
                      <mat-option [value]="source">
                        {{ source.name }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <button
                    class="add-item-btn"
                    color="primary"
                    type="button"
                    mat-button
                    (click)="createMusicSource()"
                  >
                    <mat-icon>add</mat-icon>
                    <span>Add music source</span>
                  </button>
                </div>
                <div class="property">
                  <div class="mat-body-1 property-header">Caller timeout</div>
                  <div class="field-grid-block">
                    <div class="filed-grid duration-flex">
                      <mat-form-field class="duration-select" appearance="outline">
                        <mat-select formControlName="callerTimeout">
                          @for (timeout of callerTimeouts; track timeout) {
                          <mat-option [value]="timeout">
                            {{ timeout }}
                          </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <span class="seconds-text mat-body-1">seconds</span>
                    </div>
                  </div>
                </div>
                <div class="property">
                  <div class="mat-body-1 property-header">Failover address</div>
                  <onsip-address-autocomplete
                    #failloverAddress
                    formControlName="failoverAddress"
                  ></onsip-address-autocomplete>
                </div>
                <div class="property">
                  <div class="mat-body-1 property-header">
                    Escape voicemail box
                    <mat-icon
                      [matTooltip]="
                        'When there are no agents logged into the queue, callers are redirected to an escape voicemail box.'
                      "
                      matTooltipClass="onsip-tooltip-background"
                      [matTooltipPosition]="'above'"
                      class="tool-tip-icon"
                      >help_outline
                    </mat-icon>
                  </div>
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="escapeAddress">
                      <mat-option [value]="'None'"> None </mat-option>
                      @for (voicemail of allVoicemailBoxes; track voicemail) {
                      <mat-option [value]="voicemail">
                        {{ "(Voice Mailbox) " + voicemail.name }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #queueEnhancedForm let-column>
          <div class="enhanced-settings-form-container">
            <div class="onsip-grid-placement">
              <div class="first-column">
                <div class="property">
                  <div class="enable-queue-reporting">
                    <mat-checkbox color="primary" formControlName="queueReporting">
                      <mat-label class="mat-body-1"
                        >Enable queue reporting
                        <mat-icon
                          [matTooltip]="
                            'Enables reporting of realtime caller/agent events and aggregated statistics.'
                          "
                          matTooltipClass="onsip-tooltip-background"
                          [matTooltipPosition]="'above'"
                          class="tool-tip-icon"
                          >help_outline
                        </mat-icon>
                      </mat-label>
                    </mat-checkbox>
                  </div>
                  <div class="enable-call-recording">
                    <mat-checkbox color="primary" formControlName="callRecording">
                      <mat-label class="mat-body-1"
                        >Enable call recording
                        <mat-icon
                          [matTooltip]="
                            'Records all calls in a queue and saves them to an external storage service.'
                          "
                          matTooltipClass="onsip-tooltip-background"
                          [matTooltipPosition]="'above'"
                          class="tool-tip-icon"
                          >help_outline
                        </mat-icon>
                      </mat-label>
                    </mat-checkbox>
                  </div>
                </div>
                @if (queueInfo.controls.callRecording.value) {
                <div class="property storage-prop-flex">
                  <div class="mat-body-1 property-header">Storage service</div>
                  <mat-form-field
                    appearance="outline"
                    onsip-form-field-flush-outline
                    onsip-hide-subscript-wrapper
                  >
                    <mat-select formControlName="storageService">
                      @for (service of storageServices; track service) {
                      <mat-option [value]="service">
                        {{ service?.name }}
                      </mat-option>
                      }
                    </mat-select>
                    <mat-error>{{
                      getGenericRequiredError(queueInfo.controls.storageService, "Storage service")
                    }}</mat-error>
                  </mat-form-field>
                  <button
                    class="add-storage-btn"
                    color="primary"
                    type="button"
                    mat-button
                    (click)="addStorageService()"
                  >
                    <mat-icon>add</mat-icon>
                    <span>Add storage service</span>
                  </button>
                </div>
                } @if (queueInfo.controls.callRecording.value) {
                <div class="property recording-announcement-prop">
                  <div class="mat-body-1 property-header">Recording Announcement</div>
                  <mat-radio-group color="primary" formControlName="recordingAnnouncement">
                    <mat-radio-button
                      [value]="recordingAnnouncement.none"
                      onsip-mat-radio-button-label-align-normal
                    >
                      None
                    </mat-radio-button>
                    <mat-radio-button
                      [value]="recordingAnnouncement.basic"
                      onsip-mat-radio-button-label-align-normal
                    >
                      Your call may be recorded.
                    </mat-radio-button>
                    <mat-radio-button
                      [value]="recordingAnnouncement.training"
                      onsip-mat-radio-button-label-align-normal
                    >
                      Your call may be recorded for quality assurance and training purposes.
                    </mat-radio-button>
                    <mat-radio-button
                      [value]="recordingAnnouncement.monitored"
                      onsip-mat-radio-button-label-align-normal
                    >
                      Your call may be monitored or recorded for quality assurance.
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
                } @if (queueInfo.controls.callRecording.value) {
                <div class="property recording-tone-prop">
                  <div class="mat-body-1 property-header">Recording tone</div>
                  <span class="recording-tone-container">
                    <mat-checkbox
                      color="primary"
                      class="mat-body-1"
                      formControlName="recordingTone"
                    ></mat-checkbox>
                    <mat-label class="recording-tone-text mat-body-1"
                      >Play a tone periodically during call recording</mat-label
                    >
                  </span>
                </div>
                } @if (showEditPanel) {
                <ng-template *ngTemplateOutlet="enhancedSecondColumn"></ng-template>
                }
              </div>
              @if (!showEditPanel) {
              <div class="second-column email-reports-column">
                <ng-template *ngTemplateOutlet="enhancedSecondColumn"></ng-template>
              </div>
              }
              <ng-template #enhancedSecondColumn>
                @if (queueInfo.controls.queueReporting.value) {
                <div class="property">
                  <div class="mat-body-1 property-header email-reports-header">Email reports</div>
                  <div formArrayName="emailReports">
                    @for (additionalEmail of emailReports.controls; track additionalEmail; let i =
                    $index) {
                    <div>
                      <div [formGroupName]="i" class="additional-email-block">
                        <mat-form-field appearance="outline">
                          <mat-select formControlName="frequency">
                            @for (frequency of reportFrequencies; track frequency) {
                            <mat-option [value]="frequency">
                              {{ frequency }}
                            </mat-option>
                            }
                          </mat-select>
                          <mat-error>{{
                            getGenericRequiredError(
                              emailReports.controls[i].get("frequency"),
                              "Frequency"
                            )
                          }}</mat-error>
                        </mat-form-field>
                        <div class="mat-body-1 property-header email-reports-header">
                          {{ "ONSIP_I18N.EMAIL_ADDRESS" | translate }}
                        </div>
                        <div class="email-field-with-remove-btn">
                          <mat-form-field appearance="outline">
                            <input
                              matInput
                              required
                              formControlName="email"
                              autocomplete="off"
                              [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_ADD_ENHANCED_EMAIL"
                            />
                            @if (emailReports.controls[i] && emailReports.controls[i].get('email'))
                            {
                            <mat-error>{{
                              getGenericError(emailReports.controls[i].get("email")!, "Email")
                            }}</mat-error>
                            }
                          </mat-form-field>
                          @if (!(isMobile || smallBreakpoint)) {
                          <button
                            mat-icon-button
                            type="button"
                            class="remove-email"
                            (click)="removeEmailReport(i)"
                          >
                            <mat-icon matListIcon color="primary">delete</mat-icon>
                          </button>
                          }
                        </div>
                        @if ((isMobile || smallBreakpoint)) {
                        <button
                          class="remove-email-text-btn"
                          mat-stroked-button
                          mat-button
                          color="primary"
                          type="button"
                          (click)="removeEmailReport(i)"
                        >
                          Remove
                        </button>
                        }
                      </div>
                    </div>
                    } @if (emailReports.controls.length < 7) {
                    <div>
                      <button
                        class="add-email-btn"
                        color="primary"
                        type="button"
                        mat-button
                        (click)="addEmailReport()"
                      >
                        <mat-icon>add</mat-icon>
                        <span>Add another email</span>
                      </button>
                    </div>
                    }
                  </div>
                </div>
                }
              </ng-template>
            </div>
          </div>
        </ng-template>
      </mat-horizontal-stepper>
    </form>
  </onsip-loading-container>
  <span class="mat-body-2 contact-tagline"
    >{{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
    <a class="support-link" [routerLink]="views.CONTACT_SUPPORT">
      {{ "ONSIP_I18N.SUPPORT_TEAM" | translate }}
    </a>
  </span>
</div>
}
